import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import clsx from 'clsx';
import isEqual from 'lodash/isEqual';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const MenuList = _ref => {
  let {
    colors,
    colorPallets,
    activeColorPallet,
    defaultColorPallet,
    activeCategory,
    onChange
  } = _ref;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [defaultColorPallet && defaultColorPallet.category.includes(activeCategory) ? /*#__PURE__*/_jsx(MenuItem, {
      label: defaultColorPallet.name,
      colors: defaultColorPallet.colors,
      isActive: isEqual(defaultColorPallet.colors, colors) || !colors,
      onSelect: () => onChange(defaultColorPallet.colors)
    }, defaultColorPallet.name) : null, colorPallets.map(colorPallet => {
      const isDefault = isEqual(colorPallet.colors, defaultColorPallet === null || defaultColorPallet === void 0 ? void 0 : defaultColorPallet.colors);
      if (isDefault) return null;
      const isActive = isEqual(colorPallet.colors, activeColorPallet === null || activeColorPallet === void 0 ? void 0 : activeColorPallet.colors);
      return /*#__PURE__*/_jsx(MenuItem, {
        label: colorPallet.name,
        colors: colorPallet.colors,
        isActive: isActive,
        onSelect: () => onChange(colorPallet.colors)
      }, colorPallet.name);
    })]
  });
};

const MenuItem = _ref2 => {
  let {
    label,
    colors,
    isActive = false,
    onSelect
  } = _ref2;
  return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({
    className: clsx(styles.menuItem, {
      [styles['menuItem--active']]: isActive
    })
  }, onSelect ? {
    role: 'button',
    onClick: () => onSelect()
  } : {}), {}, {
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.label,
      children: label
    }), /*#__PURE__*/_jsx(ColorPalletColors, {
      keyPrefix: label,
      colors: colors
    })]
  }));
};

const ColorPalletColors = _ref3 => {
  let {
    colors,
    keyPrefix = 'color-pallet',
    className
  } = _ref3;
  return /*#__PURE__*/_jsx("div", {
    className: clsx(styles.colors, className),
    children: colors.map((color, idx) => /*#__PURE__*/_jsx("div", {
      className: styles.color,
      style: {
        backgroundColor: color
      }
    }, `${keyPrefix}-${color}-${idx}`))
  });
};

export default MenuList;
export { ColorPalletColors };